import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'antd/es/progress/style/index.css';
import 'antd/es/tabs/style/index.css';
import 'antd/es/collapse/style/index.css';
import 'antd/es/modal/style/css.js';
import 'antd/es/table/style/css.js';
import 'antd/es/typography/style/index.css';
import 'antd/es/switch/style/index.css';
import 'antd/es/tooltip/style/index.css';
import 'antd/es/checkbox/style/index.css';
import 'antd/es/popover/style/index.css';
import './react-datepicker.css';
import 'react-phone-input-2/lib/style.css';
import './index.css';
import './style-appUsers.css';
import './style-inHouse.css';

// import { InstrumentationKey } from './app-config';
// import { ApplicationInsights } from '@microsoft/applicationinsights-web';
// import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
// import { globalHistory } from '@reach/router';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const { store, persistor } = configureStore(initialState);

// const reactPlugin = new ReactPlugin();
// const appInsights = new ApplicationInsights({
//   config: {
//     instrumentationKey: InstrumentationKey,
//     extensions: [reactPlugin],
//     extensionConfig: {
//       [reactPlugin.identifier]: { history: globalHistory },
//     },
//   },
// });
// appInsights.loadAppInsights();
// appInsights.trackPageView();

//const AppInsightApp = withAITracking(reactPlugin, <App />);

//const appInsights = ai.appInsights;
(props => {
  if (
    window.location.hash == '' ||
    window.location.hash == '#' ||
    window.location.hash == '#/login'
  ) {
    localStorage.clear();
  }
})();
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HashRouter>
        <App />
      </HashRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('wrapper'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
